export default __webpack_public_path__ + "images/models/f6b880ea2b30846f89f98f28530cf1a0.glb";